import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import _ from 'lodash';

import { WAREHOUSE_KITCHEN_HOLD_FORM_NAME } from 'Common/FormEnum';
import WarehouseHoldComponent from './../components/WarehouseHold';

class WarehouseHoldContainer extends Component {
  state = { activeIndexes: [0, 1, 2] };

  handleCollapsePanelClick = (e, titleProps) => {
    const { index } = titleProps;
    const cloneActiveIndexes = _.clone(this.state.activeIndexes);
    cloneActiveIndexes.indexOf(index) !== -1
      ? cloneActiveIndexes.splice(cloneActiveIndexes.indexOf(index), 1)
      : cloneActiveIndexes.push(index);
    this.setState({ activeIndexes: cloneActiveIndexes });
  };
  clearFilters = () => {
    this.props.reset();
    this.setState({ activeIndexes: [0, 1, 2] });
  };
  render() {
    return (
      <WarehouseHoldComponent
        activeIndexes={this.state.activeIndexes}
        handleCollapsePanelClick={this.handleCollapsePanelClick}
        clearFilters={this.clearFilters}
      />
    );
  }
}

export const WarehouseHold = reduxForm({
  form: WAREHOUSE_KITCHEN_HOLD_FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(WarehouseHoldContainer);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/warehousereport/containers/WarehouseHold.js